module.exports = __webpack_public_path__ + "static/media/experience-home-comforts.928d7593.webp";